import { DeliveryOutlined as DeliveryIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/DeliveryOutlined";
import { MyDetailsOutlined as AccountIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MyDetailsOutlined";
import { MyJlCardOutlined as MyJohnLewisIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MyJlCardOutlined";
import { OrdersOutlined as OrdersIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OrdersOutlined";
import { PackageSizeOutlined as ProductStock } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PackageSizeOutlined";
import { ReturnsAndRefundsOutlined as ReturnsIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ReturnsAndRefundsOutlined";
import { WarningOutlined as ProblemIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/WarningOutlined";
import React from "react";
import ElectricalSupportIcon from "@/assets/icons/electrical-product-support.svg";
import RepairIcon from "@/assets/icons/repair.svg";
import TvAndLaptopSupportIcon from "@/assets/icons/tv-icon.svg";

import styles from "./decision-tree-icon.module.scss";

const iconMap = {
  deliveryQueries: <DeliveryIcon size="large" />,
  returnsAndRefunds: <ReturnsIcon size="large" />,
  problemsWithProduct: <ProblemIcon size="large" />,
  productStockInformation: <ProductStock size="large" />,
  placeEditCancelOrder: <OrdersIcon size="large" />,
  myJLMembership: <MyJohnLewisIcon size="large" />,
  myAccountOnline: <AccountIcon size="large" />,
  repairUpdateElectricalItem: <img src={RepairIcon.src} alt="" className={styles.icon} />,
  tvAndLaptopSupport: <img src={TvAndLaptopSupportIcon.src} alt="" className={styles.icon} />,
  electricalProductSupport: <img src={ElectricalSupportIcon.src} alt="" className={styles.icon} />,
};

function DecisionTreeIcon({ id, className }) {
  return iconMap[id] ? (
    <span className={className} aria-hidden="true">
      {iconMap[id]}
    </span>
  ) : null;
}

export default DecisionTreeIcon;
